import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import moment from "moment";

import PtoRequestPeriodSelect from "../components/PtoRequestPeriodSelect";

const PtoRequestDayListItem = ({
  item,
  onChange,
  index,
  editing,
  disabled
}) => {
  const date = moment(item.date).format("dddd, MM/DD/YYYY");
  const handleChange = (value, order) => {
    onChange(index, value, order);
  };
  return (
    <div className="day">
      <Col xs={8}>
        <span>{date}</span>
      </Col>
      <Col xs={4}>
        <PtoRequestPeriodSelect
          value={item.period}
          onChange={handleChange}
          disabled={!editing || disabled}
          placeholder={date}
        />
      </Col>
    </div>
  );
};
PtoRequestDayListItem.propTypes = {
  item: PropTypes.object,
  onChange: PropTypes.func,
  index: PropTypes.number,
  editing: PropTypes.bool,
  disabled: PropTypes.bool
};

const PtoRequestDayList = ({ data, onChange, editing, showLabel = false }) => {
  const handleChange = (index, value, order) => {
    const days = [...data];
    days[index].period = value;
    days[index].duration = order;
    onChange("days", days);
  };
  return data?.length ? (
    <div className="day-list">
      {showLabel && (
        <Col xs={12}>
          <span>Days</span>
        </Col>
      )}
      {data.map((item, i) => (
        <PtoRequestDayListItem
          item={item}
          key={i}
          index={i}
          onChange={handleChange}
          editing={editing}
          disabled={i > 0 && i < data.length - 1}
        />
      ))}
    </div>
  ) : null;
};
PtoRequestDayList.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  showLabel: PropTypes.bool
};

export default PtoRequestDayList;
